module.exports = __webpack_public_path__ + "7563a5bc.svg";